import type { RouteRecordRaw } from 'vue-router'
import { guardAlertAccess, guardBuilder, guardMonitor } from '@/config/router/navigationsGuards/guardAlert'

const MODULE_NAME = 'ALERTS'
const MODULE_ID = 25

const defaultMeta = {
  requiresAuth: true,
  adminAccess: true,
}

const alertRoutes: Array<RouteRecordRaw> = [
  {
    path: '/alert',
    meta: {
      ...defaultMeta,
    },
    beforeEnter: [guardAlertAccess],
    children: [
      {
        path: 'monitor',
        name: 'AlertMonitor',
        component: () => import('@/views/alert/Monitor.vue'),
        meta: {
          ...defaultMeta,
          titleTranslationKey: 'pageTitle.alert.monitor',
        },
        beforeEnter: [guardMonitor],
      },
      {
        path: 'builder',
        name: 'AlertBuilder',
        component: () => import('@/views/alert/Builder.vue'),
        meta: {
          ...defaultMeta,
          titleTranslationKey: 'pageTitle.alert.builder',
        },
        beforeEnter: [guardBuilder],
      },
    ],
  },
]

export default alertRoutes.map(route => ({ ...route, meta: { ...route.meta, moduleName: MODULE_NAME, moduleId: MODULE_ID } }))
